import { Spin } from "antd";

export const SpinLoad = () => {
  return <Spin size="large" />;
};
